import type { Types as OData } from 'shared/odata'

import { apiRTK, Tag } from 'api/api-rtk'

import type * as API from './types'

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		changeExecutionQualification: create.mutation<
			API.Execution,
			Pick<API.LinkedinContact, 'id' | 'qualification'>
		>({
			invalidatesTags: [Tag.Executions],
			query: ({ id, qualification }) => ({
				data: { value: qualification },
				method: 'PUT',
				url: `executions/${id}/qualification`
			})
		}),

		completeExecution: create.mutation<API.Execution, string>({
			invalidatesTags: [Tag.Executions, Tag.Contact, Tag.Campaign],
			query: id => ({
				method: 'PUT',
				url: `executions/${id}/complete`
			})
		}),

		deleteExecutions: create.mutation<string, Partial<OData.AudienceParams>>({
			invalidatesTags: [Tag.Executions, Tag.Contact],
			query: params => ({
				method: 'DELETE',
				params,
				url: 'executions/delete'
			})
		}),

		executions: create.query<API.PageResponse, Partial<OData.Page>>({
			providesTags: [Tag.Executions],
			query: params => ({
				method: 'GET',
				params,
				url: 'executions/page'
			})
		}),

		exportExecutions: create.mutation<string, Partial<OData.AudienceParams>>({
			query: params => ({
				method: 'GET',
				params,
				url: 'executions/export'
			})
		}),

		mostRelevantExecution: create.query<
			API.Execution | string,
			API.RelevantProps
		>({
			providesTags: [Tag.Executions],
			query: params => ({
				method: 'GET',
				params,
				url: 'executions/most-relevant'
			})
		}),

		previewExecutionsDelete: create.query<
			OData.ValidationPreview,
			Partial<OData.AudienceParams>
		>({
			query: params => ({
				params,
				url: 'executions/delete/preview'
			})
		}),

		resume: create.mutation<API.Execution, string>({
			invalidatesTags: [Tag.Executions, Tag.Campaign],
			query: id => ({
				method: 'PUT',
				url: `executions/${id}/resume`
			})
		}),

		stepMessage: create.query<string, API.StepMessageProps>({
			query: ({ execution, step }) => ({
				method: 'GET',
				url: `executions/${execution}/steps/${step}/message`
			})
		})
	}),
	overrideExisting: true
})
